var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoModalPoint1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#EAEFFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(8 8)",
    fill: "#EAEFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 8.1875C23.875 8.40625 24.0312 8.78125 23.9688 9.15625L21.9688 22.1562C21.9375 22.4688 21.75 22.7188 21.4688 22.875C21.2188 23.0312 20.875 23.0625 20.5938 22.9375L16.875 21.375L14.7188 23.6875C14.4375 24 14 24.0938 13.625 23.9375C13.25 23.8125 13 23.4375 13 23V20.4062C13 20.2812 13.0312 20.1562 13.125 20.0625L18.3438 14.3438C18.5312 14.1562 18.5312 13.8438 18.3438 13.6562C18.1562 13.4688 17.8438 13.4688 17.6562 13.6562L11.3125 19.2812L8.53125 17.9062C8.21875 17.75 8 17.4062 8 17.0312C7.96875 16.6875 8.15625 16.3438 8.5 16.1562L22.5 8.15625C22.8125 7.96875 23.25 7.96875 23.5625 8.1875Z",
    fill: "#3063E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoModalPoint1);
export default __webpack_public_path__ + "static/media/info-modal-point1.cb4e0c74810f31ffb0c89bafb56da51e.svg";
export { ForwardRef as ReactComponent };